import { DISPLAY_LANG } from "../config";
import axios from "../axios";

export const getHeaderData = async () => {
    const resLogo = await axios.get('global/logo');
    const resNavbar = await axios.get(`header/navbar?lang=${DISPLAY_LANG}`);
    const resLangs = await axios.get('header/languages');
    const resAccountBtns = await axios.get('header/account_btns');

    return { 
        logo: resLogo.data, 
        navbar: resNavbar.data, 
        btns: resAccountBtns.data, 
        langs: resLangs.data,
    };
};